import { Stack, styled } from '@mui/material';

export const StyledImage = styled('img')<{ desktopWidth?: 'full' | 'half' }>(
  ({ theme, desktopWidth = 'full' }) => ({
    width: desktopWidth === 'full' ? '100%' : '50%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  })
);

export const StyledImageWrapper = styled(Stack)<{
  customWidth?: '70%' | '80%' | '90%' | '100%';
}>(({ theme, customWidth = '80%' }) => ({
  width: customWidth,
  flexDirection: 'row',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));
